<template>
    <BootstrapModal
        modalSize="l"
        ref="contactFormRef"
        modalId="contact-form"
        :title="form.title || 'Contact Form'"
        :closeText="'Close'"
        :saveText="textContactForm"
        :loading="isLoading"
        @save="submitContactForm"
        @close="closeModalContactForm"
    >
        <template #left-icon>
            <svg
                @click="showPopup = true"
                width="1.5rem"
                height="1.5rem"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.5 2.25C14.7051 2.25 13.25 3.70507 13.25 5.5C13.25 5.69591 13.2673 5.88776 13.3006 6.07412L8.56991 9.38558C8.54587 9.4024 8.52312 9.42038 8.50168 9.43939C7.94993 9.00747 7.25503 8.75 6.5 8.75C4.70507 8.75 3.25 10.2051 3.25 12C3.25 13.7949 4.70507 15.25 6.5 15.25C7.25503 15.25 7.94993 14.9925 8.50168 14.5606C8.52312 14.5796 8.54587 14.5976 8.56991 14.6144L13.3006 17.9259C13.2673 18.1122 13.25 18.3041 13.25 18.5C13.25 20.2949 14.7051 21.75 16.5 21.75C18.2949 21.75 19.75 20.2949 19.75 18.5C19.75 16.7051 18.2949 15.25 16.5 15.25C15.4472 15.25 14.5113 15.7506 13.9174 16.5267L9.43806 13.3911C9.63809 12.9694 9.75 12.4978 9.75 12C9.75 11.5022 9.63809 11.0306 9.43806 10.6089L13.9174 7.4733C14.5113 8.24942 15.4472 8.75 16.5 8.75C18.2949 8.75 19.75 7.29493 19.75 5.5C19.75 3.70507 18.2949 2.25 16.5 2.25ZM14.75 5.5C14.75 4.5335 15.5335 3.75 16.5 3.75C17.4665 3.75 18.25 4.5335 18.25 5.5C18.25 6.4665 17.4665 7.25 16.5 7.25C15.5335 7.25 14.75 6.4665 14.75 5.5ZM6.5 10.25C5.5335 10.25 4.75 11.0335 4.75 12C4.75 12.9665 5.5335 13.75 6.5 13.75C7.4665 13.75 8.25 12.9665 8.25 12C8.25 11.0335 7.4665 10.25 6.5 10.25ZM16.5 16.75C15.5335 16.75 14.75 17.5335 14.75 18.5C14.75 19.4665 15.5335 20.25 16.5 20.25C17.4665 20.25 18.25 19.4665 18.25 18.5C18.25 17.5335 17.4665 16.75 16.5 16.75Z"
                        fill="#999"
                    ></path>
                </g>
            </svg>
        </template>
        <template #body>
            <div>
                <!-- Validation message block -->
                <div
                    v-if="generalError"
                    class="alert alert-danger"
                    role="alert"
                >
                    {{ generalError }}
                </div>

                <div class="row" v-if="form.visibleFields?.name">
                    <div class="col-lg-12">
                        <FlatInput
                            inputClass="text-start"
                            label="name"
                            id="name"
                            v-model="contact.name"
                            :required="form.requiredFields?.name"
                            :error="errors.name"
                            autofocus
                            autocomplete="name"
                            placeholder="John Smith"
                            @blurred="handleFieldBlur('name')"
                        />
                    </div>
                </div>
                <div class="row mt-2" v-if="form.visibleFields?.email">
                    <div class="col-lg-12">
                        <FlatInput
                            inputClass="text-start"
                            label="email"
                            id="email"
                            type="email"
                            v-model="contact.email"
                            :required="form.requiredFields?.email"
                            autofocus
                            :error="errors.email"
                            autocomplete="email"
                            placeholder="you@example.com"
                            @blurred="handleFieldBlur('email')"
                        />
                    </div>
                </div>
                <div class="row mt-2" v-if="form.visibleFields?.phone">
                    <div class="col-lg-12">
                        <PhoneInput
                            ref="phoneInputRef"
                            id="phone"
                            label="Phone"
                            v-model="contact.mobile"
                            :error="errors.mobile"
                            :inputClass="'mb-10'"
                            :required="form.requiredFields?.phone"
                            defaultCountry="GB"
                            mode="international"
                            @blurred="handleFieldBlur('mobile')"
                            @countryChanged="countryChanged"
                        />
                    </div>
                </div>
                <div class="row mt-2" v-if="form.visibleFields?.message">
                    <div class="col-lg-12">
                        <FlatTextarea
                            label="message"
                            v-model="contact.message"
                            placeholder="Message"
                            autocomplete="message"
                            :required="form.requiredFields?.message"
                            :error="errors.message"
                            @blurred="handleFieldBlur('message')"
                        />
                    </div>
                </div>
                <div class="row mt-2" v-if="form.visibleFields?.country">
                    <div class="col-lg-12">
                        <SelectInput
                            label="Country"
                            v-model="contact.country"
                            :options="country"
                            :required="form.requiredFields?.country"
                            valueKey="code"
                            labelKey="name"
                        />
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-lg-12">
                        <AppButton
                            width="100%"
                            :disabled="disabledContactForm"
                            :loading="isLoading"
                            @buttonClick="submitContactForm"
                            ignore-plan-restriction
                            :black="true"
                        >
                            {{ textContactForm }}
                        </AppButton>
                    </div>
                </div>
            </div>
        </template>
    </BootstrapModal>

    <SharePopup
        :show="showPopup"
        :username="username"
        :urlName="urlName"
        :shortCode="shortCode"
        :DoEndpoint="DoEndpoint"
        :DoBucket="DoBucket"
        :data="data"
        @close="showPopup = false"
    />
</template>

<style>
.text-start::placeholder {
    text-align: left;
}
</style>

<script>
import AppButton from "@/Components/AppButton.vue";
import BootstrapModal from "@/Components/BootstrapModal.vue";
import FlatInput from "@/Components/FlatInput.vue";
import FlatTextarea from "@/Components/FlatTextarea.vue";
import ShareByDots from "@/Components/Links/Share/ShareByDots.vue";
import PhoneInput from "@/Components/PhoneInput.vue";
import SelectInput from "@/Components/SelectInput.vue";
import ShareMenu from "@/Components/ShareMenu.vue";
import SharePopup from "@/Components/SharePopup.vue";
import { VueTelInput } from "vue3-tel-input";
import "vue3-tel-input/dist/vue3-tel-input.css";
export default {
    components: {
        SharePopup,
        SelectInput,
        FlatTextarea,
        FlatInput,
        VueTelInput,
        AppButton,
        BootstrapModal,
        PhoneInput,
        ShareByDots,
        ShareMenu,
    },
    data() {
        return {
            showPopup: false,
            shortCode: "",
            showShareMenu: false,
            isLoading: false,
            textContactForm: "Submit",
            opacityContactForm: "1",
            disabledContactForm: false,
            contactFormLoading: "",
            recaptchaToken: "",
            generalError: "",
            errors: {
                name: "",
                email: "",
                mobile: "",
                message: "",
                country: "",
            },
            form: {
                title: "",
                visibleFields: {
                    name: true,
                    email: true,
                    phone: true,
                    message: true,
                    country: true,
                },
                requiredFields: {
                    name: false,
                    email: false,
                    phone: false,
                    message: false,
                    country: false,
                },
            },
            contact: {
                name: "",
                email: "",
                mobile: "",
                message: "",
                country: "",
                countryCode: null,
                user_id: null,
            },
            data: {}
        };
    },
    props: ["country", "username", "urlName", "DoEndpoint", "DoBucket"],
    methods: {
        openShareMenu() {
            this.showShareMenu = true;
        },
        closeModalContactForm() {
            this.$refs.contactFormRef.closeModal("contact-form");
        },
        openContactFormById(data) {
            this.shortCode = data.short_code;
            this.form = {};
            this.data = data;
            this.contact = {
                id: data.id || null,
                name: "",
                email: "",
                mobile: "",
                message: "",
                country: "",
                countryCode: "",
                user_id: data.user_id || null,
            };

            this.isLoading = true;
            this.$refs.contactFormRef.showModal("contact-form");

            setTimeout(() => {
                axios
                    .post(route("link.show.contact-form"), { id: data.id })
                    .then((response) => {
                        const contactForm = response.data.data;

                        if (contactForm && typeof contactForm === "object") {
                            this.form = {
                                ...contactForm,
                                title: response.data.title || "Contact Form",
                                visibleFields: {
                                    name: contactForm.visibleFields?.name,
                                    email: contactForm.visibleFields?.email,
                                    phone: contactForm.visibleFields?.phone,
                                    message: contactForm.visibleFields?.message,
                                    country: contactForm.visibleFields?.country,
                                },
                                requiredFields: {
                                    name: contactForm.requiredFields?.name,
                                    email: contactForm.requiredFields?.email,
                                    phone: contactForm.requiredFields?.phone,
                                    message:
                                        contactForm.requiredFields?.message,
                                    country:
                                        contactForm.requiredFields?.country,
                                },
                            };

                            this.contact.id = data.id;
                            this.contact.user_id = data.user_id;
                        } else {
                            console.error(
                                "Invalid contact form format:",
                                contactForm
                            );
                        }
                    })
                    .catch((error) => {
                        console.error(
                            "Error fetching contact form:",
                            error.response?.data || error.message
                        );
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }, 1000);
        },
        getPhoneNumber(phone, phoneobject, input) {
            if (phoneobject?.formatted) {
                this.contact.mobile = phoneobject.formatted;
            }
        },
        countryChanged(country) {
            this.contact.countryCode = country.dialCode;
        },
        handleFieldBlur(field) {
            if (this.contact[field]) {
                this.errors[field] = ""; // Clear the error for the field
            }
        },
        async submitContactForm() {
            // Reset validation message
            this.generalError = "";
            this.errors = {};
            // Check required fields and set validation messages
            const required = this.form.requiredFields || {};
            const isEmailValid = (email) =>
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

            if (required.name && !this.contact.name) {
                this.errors.name = "Name is required.";
            } else if (required.email && !this.contact.email) {
                this.errors.email = "Email is required.";
            } else if (
                required.email &&
                this.contact.email &&
                !isEmailValid(this.contact.email)
            ) {
                this.errors.email = "Invalid email format.";
            } else if (
                required.phone &&
                (!this.contact.mobile ||
                    typeof this.contact.mobile !== "object" ||
                    !this.contact.mobile.number ||
                    !this.contact.mobile.valid)
            ) {
                this.errors.mobile = "Valid phone number is required.";
            } else if (required.message && !this.contact.message) {
                this.errors.message = "Message is required.";
            } else if (required.country && !this.contact.country) {
                this.errors.country = "Country is required.";
            }

            // If there are validation errors, do not complete process
            if (Object.keys(this.errors).length > 0) return;

            try {
                // ✅ Get reCAPTCHA token
                this.recaptchaToken = await this.$recaptcha("contact_form");

                if (!this.recaptchaToken) {
                    throw new Error("Token missing");
                }
            } catch (e) {
                this.generalError =
                    "reCAPTCHA verification failed. Please refresh the page and try again.";
                return;
            }

            // Update the state before submitting the form
            this.textContactForm = "Please wait ...";
            this.opacityContactForm = "0.25";
            this.contactFormLoading = "spinner-border";
            this.disabledContactForm = true;
            this.isLoading = true;

            const payload = {
                ...this.contact,
                mobile: this.contact.mobile.number || "",
                countryCode: this.contact.mobile.country?.iso2 || null, // optional
                recaptcha: this.recaptchaToken,
            };
            // Perform the POST request using Axios
            axios
                .post(route("contact.notification.store"), payload)
                .then((response) => {
                    // Show success message
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Your message has been sent successfully!",
                    });
                    // Optionally, reset the form or close the modal
                })
                .catch((error) => {
                    // Show error message
                    this.generalError =
                        error.response?.data?.error ||
                        "There was an error submitting your form. Please try again.";
                    //console.error('Error submitting contact form:', error);
                })
                .finally(() => {
                    // Update the state after submitting the form
                    this.textContactForm = "Submitted";
                    this.opacityContactForm = "0.25";
                    this.contactFormLoading = "";
                    this.disabledContactForm = true;
                    this.isLoading = false;
                });
        },
    },
    expose: ["openContactFormById"],
};
</script>
